import React, {useEffect, useState} from 'react';
import Axios from 'axios';
import { Modal } from 'react-bootstrap';
import '../App.css';
import { useNavigate } from "react-router-dom";
import { Alert } from 'react-bootstrap';

function Grillasarolesadmin (props){
    const navigate = useNavigate();

    const [perfiles, setPerfiles] = useState([])
    const [roles, setRoles] = useState([])
    const [idrol, setIdRol] = useState()
    const [nombre, setNombre] = useState()


    const [show, setShow] = useState(false);

    
    const [showdesactivar, setShowdesactivar] = useState(false);
    const [showactivar, setShowactivar] = useState(false);
    const [showreset, setShowreset] = useState(false);
    const [showmodificar, setShowmodificar] = useState(false);
    const [showcrear, setShowcrear] = useState(false);
  

    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);

    const [tituloAlert1, setTituloAlert1] = useState('')
    const [textoAlert1, setTextoAlert1] = useState('')
    const [claseAlert1, setClaseAlert1] = useState('')
    const [alert1, setAlert1] = useState(false);

    let statuscall = '' 
    
    const dataListRoles = roles.map((item, i) =>
        <li><input type="checkbox" value={item.id}>{item.name}</input></li>);
    
    const dataListProfiles = perfiles.map((item, i) => 
    <div key={i} className='row'>
         <div className='saLineGrid col col-xl-3 col-lg-3 col-md-3 col-sm-3'>{item.id}</div>
         <div className='saLineGrid col col-xl-3 col-lg-3 col-md-3 col-sm-3'>{item.nombre}</div>         
         <div className='saLineGrid col col-xl-3 col-lg-3 col-md-3 col-sm-3'><button onClick={() => perfilarRoles(item)} className='btn btn-adminsaprivateRegular'>Perfilar</button></div>         
    </div>);

    useEffect(() => {
        Axios.get(process.env.REACT_APP_PROFILES_ROLES, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setPerfiles(response.data.perfiles)
            setRoles(response.data.roles)
        }).catch(error => {
            return error     
        });
    }, []);


    const handleCloseShow = () => setShow(false)

    const handleShow = () => setShow(true)

    const perfilarRoles  = (item) => {
        setIdRol(item.id)
        setNombre(item.nombre)
        handleShow()

        //Cargar 
    }




    
    return(
    <div className='container'>
        <div className='col col-xl-12 col-lg-12 col-md-12 col-sm-12'>
                        
            <div className='row sabackComponent'>
                <div className='col col-xl-12 col-lg-12 col-md-12 col-sm-12'>
                    <h4>Administracion de roles y perfiles</h4>
                </div> 
            </div>

            <div className='row sabackComponent'>
                    <div className='row saTitulosGrid'>
                        <div className='col col-xl-3 col-lg-3 col-md-3 col-sm-3'>Id</div>
                        <div className='col col-xl-3 col-lg-3 col-md-0 col-sm-0'>Nombre Rol</div>
                        <div className='col col-xl-3 col-lg-3 col-md-0 col-sm-0'>Control</div>
                    </div> 
                    <div className='row saContainerGrid'>               
                        {dataListProfiles}
                    </div>
            </div>
        </div>        


        <Modal show={show} onHide={handleCloseShow} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Administracion de usuarios</Modal.Title>
            </Modal.Header>
            <Modal.Body>


                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alert
                        ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlert}</Alert.Heading>
                                <p>
                                    {textoAlert}
                                </p>
                                <hr></hr>
                                <p class="mb-0"><button className='btn btn-adminsaprivateRegular'>Confirmar</button><button className='btn btn-adminsaprivateRegular' onClick={() => setAlert(false)}>Rechazar</button></p>    
                        </Alert>
                        :''
                        }

                        {alert1
                        ?<Alert variant={claseAlert1} onClose={() => setAlert1(false)} dismissible fade show>
                        <Alert.Heading>{tituloAlert1}</Alert.Heading>
                            <p>
                                {textoAlert1}
                            </p>
                        </Alert>
                        :''                            
                        }
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Rol                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' value={nombre} disabled='true'></input>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className='btn btn-adminsaprivateRegular' onClick={handleCloseShow}>
                    Cerrar
                </button>
                <button className='btn btn-adminsaprivateRegular'>
                    Guardar Perfil
                </button>
            </Modal.Footer>
        </Modal>
    </div>    
    )
}
export default Grillasarolesadmin